import styled from 'styled-components';
import { variables } from '../../../styles/variables';

export const SuperTeacherPanelContainer = styled('div')`
  button {
    margin: 0;
    outline: none;
    background-color: ${variables.colorWhite};
    font-weight: 600;
    position: relative;
    &:hover, &:focus {
      background-color: ${variables.colorWhite};
    }
    &:focus-visible {

    }
  }
  span {
    font-size: 1.6rem;
  }

  @media (max-width: 786px), (max-height: 567px) {
    button {
      width: max-content;
    }
  }
`;
